
import { Vue, Component } from 'vue-property-decorator';
import VoucherService from '@/services/voucher.service';
import lazyInject from '@/di';
import CarService from '@/services/car.service';

@Component
export default class CorrelationOrderDrawer extends Vue {
  visible = false;

  @lazyInject(VoucherService)
  voucherService!: VoucherService;

  @lazyInject(CarService)
  carService!: CarService;


  ordrtList: any[] = [];

  totalPrice = 0;

  async init(record: any) {
    const res = await this.carService.getShopOrderList({
      flow_no: record.flow_no,
      channel: record.channel,

    });
    console.log(res, 'sssssssss');
    this.ordrtList = res.list;
    this.totalPrice = res.total_price;
    this.visible = true;
  }

  onClose() {
    this.visible = false;
  }

  deleOrder(order: any) {
    const content = '是否删除订单与收款凭证的绑定关系？';
    console.log(order);
    this.$confirm({
      title: '提示',
      content,
      onOk: () => {
        console.log('ok');
      },
      onCancel: () => {
        console.log('cancel');
      },
    });
  }
}
